import { captureException } from '@sentry/react';

import { isAbortedFetch } from 'shared/utils/isAbortedFetch';

export const logError = (error) => {
  // Navigation-aborted fetches never reach the server — not a real error.
  if (isAbortedFetch(error)) {
    return;
  }

  captureException(error);
  console.error(error);
};
